import { Selector } from "@ngxs/store";
import { ScheduleState, ScheduleStateModel } from "./schedule.state";

export class ScheduleSelectors {
    @Selector([ScheduleState])
    static dailyScheduleList(state: ScheduleStateModel) {
        return state.dailyScheduleList;
    }
    @Selector([ScheduleState])
    static getConfigOpen(state: ScheduleStateModel) {
        return state.scheduleConfigOpen;
    }

    @Selector([ScheduleState])
    static fetchHistory(state: ScheduleStateModel) {
        return state.fetchHistory;
    }

    @Selector([ScheduleState])
    static scheduleList(state: ScheduleStateModel) {
        return state.scheduleList;
    }

    @Selector([ScheduleState])
    static setVisibleSchedule(state: ScheduleStateModel) {
        return state.onlyDataShowing;
    }

    @Selector([ScheduleState])
    static currentDate(state: ScheduleStateModel) {
        return state.currentDate;
    }

    @Selector([ScheduleState])
    static scheduleConfig(state: ScheduleStateModel) {
        return state.scheduleConfig;
    }

    @Selector([ScheduleState])
    static scheduleRole(state: ScheduleStateModel) {
        return state.scheduleConfigRole;
    }

    @Selector([ScheduleState])
    static existingFilter(state: ScheduleStateModel) {
        return state.existingFilter;
    }
}